import React from "react";
import { Field, Formik } from "formik";
import { connect } from "react-redux";
import { compose } from "recompose";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import AuthModule from "modules/auth";
import ROUTES from "config/routes";
import Input from "components/Input";
import Checkbox from "components/Checkbox";
import Button from "components/Button";
import { userTypesCaregivers } from "config/constants";

function CaregiversRegistrationForm(props) {
  const { signUp, slug, isFetching } = props;

  const { executeRecaptcha } = useGoogleReCaptcha();

  return (
    <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        confirm_password: "",
        agreement: false,
      }}
      validationSchema={Yup.object().shape({
        first_name: Yup.string()
          .min(3, "Too Short!")
          .max(32, "Too Long!")
          .required("Required"),
        last_name: Yup.string()
          .min(3, "Too Short!")
          .max(32, "Too Long!")
          .required("Required"),
        email: Yup.string()
          .min(5, "Too Short!")
          .max(64, "Too Long!")
          .email("Invalid email")
          .required("Required"),
        password: Yup.string()
          .min(6, "Too Short!")
          .max(16, "Too Long!")
          .required("Required"),
        confirm_password: Yup.string()
          .min(6, "Too Short!")
          .max(16, "Too Long!")
          .required("Required")
          .test("passwords-match", "Values doesnt match", function (value) {
            return this.parent.password === value;
          }),
        agreement: Yup.boolean().oneOf([true], "Field must be checked"),
      })}
      onSubmit={async (values, bag) => {
        const token = await executeRecaptcha("register");

        const roleItem = userTypesCaregivers.find((item) => item.slug === slug);
        const sendData = {
          ...values,
          role: roleItem.slug,
          ["g-recaptcha-response"]: token,
        };

        signUp(sendData);

        bag.resetForm();
      }}
    >
      {(props) => {
        return (
          <form onSubmit={props.handleSubmit}>
            <div className="form-section">
              <div className="title-required text-center">
                Required Fields<span className="title-required__sign">*</span>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-lg-4 offset-lg-4">
                <div className="field-wrap">
                  <Field
                    name="first_name"
                    type="text"
                    placeholder="First Name"
                    component={Input}
                    isRequired={true}
                  />
                </div>
                <div className="field-wrap">
                  <Field
                    name="last_name"
                    type="text"
                    placeholder="Last Name"
                    component={Input}
                    isRequired={true}
                  />
                </div>
                <div className="field-wrap">
                  <Field
                    name="email"
                    type="email"
                    placeholder="Email Address"
                    component={Input}
                    isRequired={true}
                  />
                </div>
                <div className="field-wrap">
                  <Field
                    name="password"
                    type="password"
                    placeholder="Password"
                    component={Input}
                    icon="password"
                    isRequired={true}
                  />
                </div>
                <div className="field-wrap">
                  <Field
                    name="confirm_password"
                    type="password"
                    placeholder="Confirm Password"
                    component={Input}
                    icon="password"
                    isRequired={true}
                  />
                </div>
                <div className="field-wrap">
                  <Field name="agreement" component={Checkbox}>
                    I agree with{" "}
                    <Link
                      to={ROUTES.terms}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </Link>
                  </Field>
                </div>

                <div className="field-wrap text-center">
                  <Button bgColor="green" type="submit" showLoader={isFetching}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </form>
        );
      }}
    </Formik>
  );
}

export default compose(
  connect(
    (state) => ({
      isFetching: state.auth.isFetching,
      isFetched: state.auth.isFetched,
    }),
    {
      signUp: AuthModule.signUp,
    }
  )
)(CaregiversRegistrationForm);
